namespace RioERP.Reports {
    export interface AddBookForm {
        OrderId: Serenity.StringEditor;
        BookIsbn: Serenity.StringEditor;
    }

    export class AddBookForm extends Serenity.PrefixedContext {
        static formKey = 'Reports.AddBook';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AddBookForm.init)  {
                AddBookForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(AddBookForm, [
                    'OrderId', w0,
                    'BookIsbn', w0
                ]);
            }
        }
    }
}
